
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaicabservice() {



    const cardData =
    {
        keyword: 'Mumbai Cab Service',
        heading: 'S9 Travels:  Mumbai Cab Service',
        headingDescription: 'S9 Travels offers Mumbai Cab Service, providing a comfortable, reliable, and premium travel experience. Whether you need a cab for airport transfers, business meetings, sightseeing, or outstation trips, our well-maintained Innova cabs ensure a smooth and hassle-free journey. With spacious interiors, luxury features, and professional drivers, we guarantee a safe and enjoyable ride. Book with S9 Travels for a seamless travel experience between Pune and Mumbai',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "One of Mumbai’s most iconic landmarks, the Gateway of India overlooks the Arabian Sea. Built in 1924, this grand arch is a popular tourist attraction and a historical symbol of colonial-era Mumbai."
    },
    {
      "title": "Marine Drive",
      "description": "A scenic boulevard along the coast, Marine Drive is perfect for evening strolls. Also known as the 'Queen’s Necklace' due to its streetlights forming a necklace-like shape at night, it's a must-visit for breathtaking sunset views."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "description": "A UNESCO World Heritage site, this historic railway station is an architectural masterpiece. Its Indo-Gothic design and intricate detailing make it one of Mumbai’s most stunning structures."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these ancient rock-cut caves feature magnificent sculptures of Hindu deities. The main cave is dedicated to Lord Shiva and is a UNESCO World Heritage site."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most famous beaches, Juhu Beach is known for its vibrant street food stalls offering local favorites like pav bhaji and bhel puri. It’s a great spot to relax and enjoy the sea breeze."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A lush green sanctuary in the heart of Mumbai, this park is home to diverse flora and fauna. Visitors can enjoy nature trails, the Kanheri Caves, and even a lion and tiger safari."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "An iconic religious site, this mosque and tomb are located on a small island off the Mumbai coast. The causeway leading to the shrine offers stunning views of the sea."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shoppers and food lovers, Colaba Causeway is famous for its street markets, cafes, and colonial-era architecture. It’s the perfect place for picking up souvenirs and trendy accessories."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "A modern engineering marvel, this cable-stayed bridge connects Bandra and Worli. It offers stunning views of Mumbai’s skyline, especially when lit up at night."
    },
    {
      "title": "Chor Bazaar",
      "description": "One of the oldest and most famous flea markets in Mumbai, Chor Bazaar is known for its antiques, vintage items, and unique collectibles. It’s a great place to explore for bargain hunters and history lovers."
    }
],

"services": [
    {
      "name": "Mumbai Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services in Mumbai. Whether you need a ride for local travel, an airport transfer, or a city tour, we ensure you travel safely and efficiently with our professional drivers and well-maintained vehicles."
    },
    {
      "name": "Book a Cab in Mumbai",
      "description": "Booking a cab in Mumbai has never been easier! With S9 Travels, you can easily book a cab for your needs—whether it’s a quick trip to a local destination or a long-distance journey across the city. We offer convenience and reliability at your fingertips."
    },
    {
      "name": "Affordable Taxi Services in Mumbai",
      "description": "Looking for affordable taxi services in Mumbai? S9 Travels provides cost-effective options without compromising on quality. We offer budget-friendly cab services for both short and long-distance travel around the city."
    },
    {
      "name": "Mumbai Private Car Hire",
      "description": "For those who prefer a more exclusive ride, S9 Travels offers private car hire services in Mumbai. Choose from a variety of premium cars for a luxurious travel experience, whether for business or leisure trips."
    },
    {
      "name": "Taxi Service for Local Travel in Mumbai",
      "description": "S9 Travels provides reliable taxi services for local travel within Mumbai. Whether you’re heading to a meeting, visiting popular tourist attractions, or running errands, our taxis offer a comfortable and convenient way to travel around the city."
    },
    {
      "name": "Mumbai Car Rental Service",
      "description": "If you need a car for a day or an extended period, S9 Travels offers flexible car rental services in Mumbai. Choose from a wide range of vehicles to suit your travel needs, whether it's for business or a leisurely exploration of the city."
    },
    {
      "name": "Professional Cab Service in Mumbai",
      "description": "S9 Travels offers professional and courteous cab services in Mumbai. Our experienced drivers ensure a smooth and safe ride, providing top-notch service for both business and leisure travel."
    },
    {
      "name": "Private Cabs for Tourists in Mumbai",
      "description": "Touring Mumbai? S9 Travels offers private cabs for tourists, providing a comfortable and hassle-free way to explore the city's famous landmarks, restaurants, and attractions with the flexibility of personalized routes and stops."
    },
    {
      "name": "Mumbai Taxi Booking Online",
      "description": "Easily book your taxi in Mumbai with S9 Travels online booking system. Whether you're planning a short trip or a day-long journey, booking a cab has never been more convenient, with real-time booking and confirmation."
    },
    {
      "name": "Corporate Taxi Service in Mumbai",
      "description": "S9 Travels provides tailored corporate taxi services in Mumbai, designed to meet the needs of businesses. From airport transfers to employee transport, our professional cab services ensure that your business travel is punctual, reliable, and comfortable."
    },
    {
      "name": "Mumbai City Tour Taxi",
      "description": "Explore Mumbai like never before with S9 Travels' city tour taxi service. Our knowledgeable drivers will take you to all the top tourist spots, ensuring you have a comfortable and enjoyable sightseeing experience."
    },
    {
      "name": "Luxury Car Hire in Mumbai",
      "description": "For those seeking luxury, S9 Travels offers luxury car hire services in Mumbai. Whether for business, a special event, or a luxurious day out, our premium fleet ensures a smooth and opulent ride across the city."
    },
    {
      "name": "Mumbai Taxi Service Providers",
      "description": "S9 Travels is one of the leading taxi service providers in Mumbai, offering reliable, professional, and affordable transportation. From daily commutes to special trips, we ensure your ride is always comfortable and on time."
    }
],

"tableData": [
  ["Mumbai Cab Service", "Book a Cab in Mumbai"],
  ["Affordable Taxi Services in Mumbai", "Mumbai Private Car Hire"],
  ["Taxi Service for Local Travel in Mumbai", "Mumbai Car Rental Service"],
  ["Professional Cab Service in Mumbai", "Private Cabs for Tourists in Mumbai"],
  ["Mumbai Taxi Booking Online", "Corporate Taxi Service in Mumbai"],
  ["Mumbai City Tour Taxi", "Luxury Car Hire in Mumbai"],
  ["Mumbai Taxi Service Providers", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and Timely Service in Mumbai",
    "WhyChoosedescription": "S9 Travels offers dependable cab services across Mumbai, ensuring that you never have to worry about being late for your appointments, meetings, or events. Our drivers are trained to prioritize punctuality, ensuring timely pick-ups and drop-offs in the city."
  },
  {
    "WhyChooseheading": "Comfortable Rides Across Mumbai",
    "WhyChoosedescription": "Experience comfort like never before with our well-maintained vehicles, including the Toyota Innova. Whether you're navigating the busy streets of Mumbai or traveling longer distances, our cabs offer air-conditioned, spacious interiors that make your journey comfortable and stress-free."
  },
  {
    "WhyChooseheading": "Experienced and Knowledgeable Drivers",
    "WhyChoosedescription": "Our drivers are not only experienced but also familiar with the diverse traffic patterns of Mumbai. Whether it's a busy rush hour or navigating through narrow lanes, our drivers know how to get you to your destination efficiently, ensuring a smooth journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for Mumbai cab services, with no hidden charges. Our pricing is transparent, so you can always know the cost of your ride upfront. We offer a clear breakdown during the booking process to help you plan your travel budget."
  },
  {
    "WhyChooseheading": "Safe and Secure Journey Through Mumbai",
    "WhyChoosedescription": "Safety is paramount in every ride with S9 Travels. Our cabs are equipped with modern safety features such as GPS tracking, seat belts, and airbags, so you can travel across Mumbai with peace of mind, knowing you're in safe hands."
  },
  {
    "WhyChooseheading": "24/7 Availability in Mumbai",
    "WhyChoosedescription": "Whether you need a cab for early morning airport transfers or a late-night ride, S9 Travels is available 24/7 in Mumbai. Our customer service team is ready to assist you anytime, ensuring you always have access to reliable transport whenever you need it."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab with S9 Travels in Mumbai is simple and convenient. You can book online via our website or mobile app, or contact our customer service team for personalized assistance. Our easy-to-use booking system ensures that your travel needs are met quickly and efficiently."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Mumbai",
    "WhyChoosedescription": "Whether you're planning a sightseeing tour, business trip, or special event, we offer customized travel plans for your time in Mumbai. Let us know your preferences, and we'll tailor the trip to your needs, ensuring a unique and comfortable experience in the city."
  }
]









    }



    const faqData = [
        [
          {
            question: 'How can I book a cab service in Mumbai with S9 Travels?',
            answer: 'Booking a cab in Mumbai with S9 Travels is simple! You can easily book online through our website or app, or contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for cab services in Mumbai?',
            answer: 'We offer a range of vehicles for your convenience, including sedans, SUVs, and premium cars like the Toyota Innova, perfect for city travel, business trips, or sightseeing around Mumbai.',
          },
          {
            question: 'Can I book a cab for a full day in Mumbai?',
            answer: 'Yes, we offer full-day cab bookings for your convenience. Whether it is for business meetings, shopping, or sightseeing, our cabs are available to you for the entire day in Mumbai.',
          },
          {
            question: 'Are the drivers experienced and knowledgeable about Mumbai?',
            answer: 'Absolutely! Our drivers are highly experienced and familiar with the roads, traffic conditions, and key locations in Mumbai. They ensure a safe, smooth, and punctual ride throughout the city.',
          },
          {
            question: 'Can I book a cab for airport transfers in Mumbai?',
            answer: 'Yes, we provide reliable airport transfers to and from Chhatrapati Shivaji Maharaj International Airport (BOM). We ensure timely pickups and drop-offs, so you can start or end your journey stress-free.',
          },
          {
            question: 'Is there a cancellation policy for cab bookings in Mumbai?',
            answer: 'Yes, we have a cancellation policy. If you need to cancel your booking, please do so within the specified time frame to avoid cancellation charges. Contact us for more details.',
          },
          {
            question: 'Do you offer corporate or group travel services in Mumbai?',
            answer: 'Yes, we provide corporate cab services for business meetings, events, and group travel in Mumbai. Whether it’s a small team or a larger group, we can accommodate all your transportation needs.',
          },
          {
            question: 'Can I request a cab for sightseeing around Mumbai?',
            answer: 'Yes, we offer sightseeing tours around Mumbai! Explore popular attractions like the Gateway of India, Marine Drive, and the Elephanta Caves with the comfort of a private, well-maintained vehicle.',
          },
          {
            question: 'How do I ensure the cab is available on time in Mumbai?',
            answer: 'At S9 Travels, punctuality is our priority. We monitor traffic and adjust our schedules to ensure your cab arrives on time. You can also track your ride through our app for real-time updates.',
          },
          {
            question: 'Why should I choose S9 Travels for my cab service in Mumbai?',
            answer: 'S9 Travels provides reliable, safe, and affordable cab services in Mumbai. With professional drivers, clean vehicles, and excellent customer service, we ensure a comfortable and stress-free ride for all your transportation needs.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Arjun Desai',
          designation: 'Business Executive',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made my business trip to Mumbai so much easier. The vehicle was clean, the driver was professional, and the service was punctual. I highly recommend their Mumbai cab service for anyone visiting the city for business or leisure.”',
        },
        {
          name: 'Mrs. Neelam Patil',
          designation: 'Tourist',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for sightseeing in Mumbai, and the experience was fantastic. The driver was knowledgeable, and we got to see all the major tourist spots in comfort. I would definitely recommend their Mumbai cab service for tourists.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Cab Service",
        "description": "Book affordable and professional cab services in Mumbai for local travel, city tours, corporate events, and private car hire. S9 Travels offers reliable taxi services, luxury car rentals, and convenient online taxi booking for tourists and residents in Mumbai.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
   
      
     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Mumbai Cab Service | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book affordable Mumbai cab services for local travel, city tours, private car hire, and corporate needs. Reliable taxi booking for tourists, luxury car hire, and online taxi services in Mumbai with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaicabservice;